import React, {useEffect, useRef, useState} from 'react';
import Highcharts from 'highcharts';
// import HighchartsReact from 'highcharts-react-official';
import { Empty } from 'antd';
import exportingOption from 'highcharts/modules/exporting';
import offlineOption from 'highcharts/modules/offline-exporting';

Highcharts.setOptions({lang: {thousandsSep: ','}})
exportingOption(Highcharts);
offlineOption(Highcharts);

// needed for rendering datalabel within a circle
Highcharts.SVGRenderer.prototype.symbols.roundCircle = function (x, y, w, h) {
  let width = w,
    height = h,
    newX = x;
  if (height > width) {
    width = height;
    newX -= (width - w) / 2;
  } else if (width > height) {
    height = width;
  }
  return Highcharts.SVGRenderer.prototype.symbols.circle(newX, y, width, height);
};

export const ScatterplotChart = React.memo(({ data, xPlotlines, yPlotlines, options, height = '100%'}) => {

  const containerRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    // Destroy the chart if it already exists to avoid conflicts
    if (chartRef.current) {
      chartRef.current.destroy();
    }

    // Reinitialize the chart with updated options
    if (containerRef.current) {
      chartRef.current = Highcharts.chart(containerRef.current, {
        ...options,
        chart: {
          ...options.chart,
          height,
        },
      });
    }
  }, [data, xPlotlines, yPlotlines]);

  // Show a placeholder if no valid options are provided
  if (!options || !options.series || !Array.isArray(options.series)) {
    return <Empty description="No data in the specified date range" />;
  }

  return <div ref={containerRef} style={{ width: '100%', height }} />;
});